import React, { useEffect, useState } from 'react';
import { Box, Typography, FormControlLabel, Checkbox, Button } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import { useTranslation } from 'react-i18next';

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isInStandaloneMode = () => ('standalone' in window.navigator) && window.navigator.standalone;

const IOSSafariInstallBanner = () => {
  const [hideModal, setHideModal] = useState(false);
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const previouslyDismissed = localStorage.getItem('showIOSInstallBanner') === 'false';
    if (!previouslyDismissed && isIOS() && !isInStandaloneMode()) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    if (hideModal) {
      localStorage.setItem('showIOSInstallBanner', 'false');
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fefefe',
        borderTop: '1px solid #ccc',
        padding: 2,
        zIndex: 1000,
        textAlign: 'center',
        alignItems: 'center',
        boxShadow: '0 -2px 6px rgba(0,0,0,0.1)',
      }}
    >
      <Typography dangerouslySetInnerHTML={{ __html: t('a2hs.ios_instruction1') }} />
      <Box sx={{ my: 1 }}>
        <Typography dangerouslySetInnerHTML={{ __html: t('a2hs.ios_instruction2') }} display="inline" />
        <IosShareIcon sx={{ verticalAlign: 'middle', mx: 1 }} />
      </Box>
      <Typography dangerouslySetInnerHTML={{ __html: t('a2hs.ios_instruction3') }} />

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 1,
      }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={hideModal}
              onChange={(e) => setHideModal(e.target.checked)}
            />
          }
          label={t('modal_config.dont_show_again')}
          sx={{ mt: 1 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleClose}
          sx={{ mt: 1, width: "80%" }}
        >
          {t('modal_config.close_button')}
        </Button>
      </Box>
    </Box>
  );
};

export default IOSSafariInstallBanner;